import React from 'react';

export const DownloadPdfDonorIntent = ({ blobPdf }) => {
  const fileURL = window.URL.createObjectURL(blobPdf);

  return (
    <a download="Donors intent. Mission statement.pdf" href={fileURL}>
      <i className="bi bi-cloud-arrow-down-fill text-dark" />
    </a>
  );
};
